// extracted by mini-css-extract-plugin
module.exports = {"component":"LanguageSelect_component__1U1yZ","readOnly":"LanguageSelect_readOnly__3WDHM","downdownIcon":"LanguageSelect_downdownIcon__2BUYD","icon":"LanguageSelect_icon__3j5hx"};